import { DeviceConfigParams } from "../../DeviceConfigParams";
export class MultisensorDetectionThresholdParams extends DeviceConfigParams {
    constructor() {
        super(...arguments);
        this.Channel = Rcm21Channels.Unknow;
        this.Threshold = 0;
        this.Hysteresis = false;
        this.IsHysteresisOptionAvailable = false;
        this.IsOffsetOptionAvailable = false;
    }
}
export class MultisensorIntervalParams extends DeviceConfigParams {
    constructor() {
        super(...arguments);
        this.Interval = 0;
    }
}
export class MultisensorChannelOffsetParams extends DeviceConfigParams {
    constructor() {
        super(...arguments);
        this.Channel = Rcm21Channels.Unknow;
        this.Offset = 0;
    }
}
export var Rcm21Channels;
(function (Rcm21Channels) {
    Rcm21Channels[Rcm21Channels["Unknow"] = 0] = "Unknow";
    Rcm21Channels[Rcm21Channels["TemperatureChannel"] = 1] = "TemperatureChannel";
    Rcm21Channels[Rcm21Channels["HuminidityChannel"] = 2] = "HuminidityChannel";
    Rcm21Channels[Rcm21Channels["PressureChannel"] = 3] = "PressureChannel";
    Rcm21Channels[Rcm21Channels["BrightnessChannel"] = 4] = "BrightnessChannel";
})(Rcm21Channels || (Rcm21Channels = {}));
//# sourceMappingURL=Rcm21ConfigParams.js.map